import { atom, selector } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";
import { savedDisplayOperationState, useDisplayOperationRecoilState } from "../hooks/useDisplayOperation";
import { getProperty } from "../utils/FPEUtils";

const crossSectionColorState = atom({
  key: 'crossSectionColorState',
  default: selector({
    key: 'crossSectionColorStateSelector',
    get: ({get}) => {
      return getProperty(get(savedDisplayOperationState), 'SCREEN_SETTING.CROSSSECTION_COLOR') || getCustomerSettings("mapConfig.CROSSSECTION_COLOR");
    }
  })
});

export const useCsColorState = () => {
  const [csColor, setCsColor] = useDisplayOperationRecoilState('SCREEN_SETTING.CROSSSECTION_COLOR', crossSectionColorState);

  const isLightCs = csColor === 'white';
  const isDarkCs = !isLightCs;

  const changeCsColorDark = ()=>{
    setCsColor('black');
  }
  const changeCsColorLight = () => {
    setCsColor('white');
  };

  return {
    csColor,
    isLightCs,
    isDarkCs,
    changeCsColorDark,
    changeCsColorLight
  }
}